// src/admin/AppAdmin.jsx
import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./layout/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Members from "./pages/Members";
import MemberDetail from "./pages/MemberDetail";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Bookings from "./pages/Bookings";
import NewBooking from "./pages/NewBooking";
import NewMember from "./pages/NewMember";
import "./styles/admin.css";
import NewVehicle from "./pages/NewVehicle";
import BookingDetail from "./pages/BookingDetail";

export default function AppAdmin() {
  return (
    <AdminLayout>
      <Routes>
        {/* /admin */}
        <Route index element={<Navigate to="dashboard" replace />} />

        {/* /admin/dashboard */}
        <Route path="dashboard" element={<Dashboard />} />

        {/* /admin/members */}
        <Route path="members" element={<Members />} />
        <Route path="members/new" element={<NewMember />} />
        <Route path="members/:memberId" element={<MemberDetail />} />

        {/* /admin/vehicles */}
        <Route path="vehicles" element={<Vehicles />} />
        <Route path="vehicles/new" element={<NewVehicle />} />
        <Route path="vehicles/:vehicleId" element={<VehicleDetail />} />
       

        {/* /admin/bookings */}
<Route path="bookings" element={<Bookings />} />
<Route path="bookings/new" element={<NewBooking />} />
<Route path="bookings/:bookingId" element={<BookingDetail />} />

        {/* fallback */}
        <Route path="*" element={<div style={{ padding: 24 }}>Not found</div>} />
      </Routes>
    </AdminLayout>
  );
}